import { render, staticRenderFns } from "./Redeemed.vue?vue&type=template&id=7e6510c3&"
import script from "./Redeemed.vue?vue&type=script&lang=ts&"
export * from "./Redeemed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports